interface ValidateUploadParams {
    files: File[];
    uploadedFile: File;
    tempId: string | undefined;
    newFilesLength: number;
}
export function validateUpload(
    { files, uploadedFile, tempId, newFilesLength }: ValidateUploadParams,
) {
    if (!tempId) {
        return {
            valid: false,
            message: "Temporary ID is required for file upload.",
            type: "missing_temp_id",
        };
    }
    // Check if the file already exists in the list
    const fileExists = files.some((file) => file.name === uploadedFile.name);
    if (fileExists) {
        return {
            valid: false,
            message:
                "File name already already exists in the upload list. Please rename the file and try again.",
            type: "file_exists",
        };
    }

    // Check if the maximum number of files (5) has been reached
    console.log("Current files:", files.length);
    if (files.length >= 5 || files.length + newFilesLength > 5) {
        return {
            valid: false,
            message: "You can only upload a maximum of 5 files.",
            type: "max_files_reached",
        };
    }

    // Check file size limit (15MB)
    if (uploadedFile.size > 15 * 1024 * 1024) {
        return {
            valid: false,
            message: "File exceeds the 15MB size limit.",
            type: "file_size_exceeded",
        };
    }

    // Check file type (PDF, JPG, JPEG, PNG)
    const validTypes = ["application/pdf", "image/jpeg", "image/png"];
    if (!validTypes.includes(uploadedFile.type)) {
        return {
            valid: false,
            message:
                "Invalid file type. Only PDF, JPG, JPEG, and PNG are allowed.",
            type: "invalid_file_type",
        };
    }

    return { valid: true, message: "file passes validation" };
}
